import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M18.364 5.364a9.2 9.2 0 0 1 2.463 4.69 9.3 9.3 0 0 1-.512 5.292A9.13 9.13 0 0 1 17 19.456 8.9 8.9 0 0 1 12 21c-1.78 0-3.52-.537-5-1.544a9.13 9.13 0 0 1-3.315-4.11 9.3 9.3 0 0 1-.512-5.292 9.2 9.2 0 0 1 2.463-4.69M12 3v4.727"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }